export enum RecipientAliasType {
    RM = 'RM',
    HELPCENTER = 'HELPCENTER',
}
